import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5606d26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"color":"#08c"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { title: "权限菜单" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "formRef",
        model: _ctx.formState,
        rules: _ctx.rules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            ref: "pid",
            label: "上级菜单",
            name: "pid"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tree_select, {
                value: _ctx.formState.pid,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.pid) = $event)),
                placeholder: "请选择上级菜单",
                "tree-line": true,
                "allow-clear": "",
                "tree-data": _ctx.allMenu,
                fieldNames: {children:'sub', label:'title', key:'id', value: 'id' }
              }, {
                title: _withCtx(({ value: val, title }) => [
                  (val === _ctx.formState.pid)
                    ? (_openBlock(), _createElementBlock("b", _hoisted_1, _toDisplayString(title), 1))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(title), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["value", "tree-data"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "title",
            label: "菜单名称",
            name: "title"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.title,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.title) = $event)),
                placeholder: "请输入菜单名称"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "type",
            label: "菜单类型",
            name: "type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.type,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.type) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.permissionTypes, (item) => {
                    return (_openBlock(), _createBlock(_component_a_radio, {
                      value: item.id,
                      key: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "uri",
            label: "接口地址",
            name: "uri"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.uri,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.uri) = $event)),
                placeholder: "请输入权限标识"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          (_ctx.formState.type === 3)
            ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                ref: "front_url",
                label: "路由地址",
                required: "",
                help: "路由地址不能为空",
                name: "front_url"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.formState.front_url,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.front_url) = $event)),
                    placeholder: "请输入路由地址"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 512))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form_item, {
            ref: "sort",
            label: "排序",
            name: "sort"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _ctx.formState.sort,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.sort) = $event)),
                type: "number",
                placeholder: "请输入"
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            ref: "disable",
            label: "状态",
            name: "disable"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio_group, {
                value: _ctx.formState.disable,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.disable) = $event)),
                "button-style": "solid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio, { value: 0 }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio, { value: 1 }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 512),
          _createVNode(_component_a_form_item, {
            "wrapper-col": { span: 14, offset: 4 },
            style: {"margin-top":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.onSubmit,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["onClick", "loading"]),
              _createVNode(_component_a_button, {
                style: {"margin-left":"10px"},
                onClick: _ctx.goBack,
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"])
    ]),
    _: 1
  }))
}